import { render, staticRenderFns } from "./TechName.vue?vue&type=template&id=13c5f992&"
import script from "./TechName.vue?vue&type=script&lang=js&"
export * from "./TechName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports